import { render, staticRenderFns } from "./BrakeInspectionComponent.vue?vue&type=template&id=22cb2816&"
import script from "./BrakeInspectionComponent.vue?vue&type=script&lang=js&"
export * from "./BrakeInspectionComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports